import {Component, Input} from "@angular/core";


@Component({
    selector: 'checkbox-circle',
    imports: [],
    templateUrl: './checkbox-circle.component.html'
})
export class CheckboxCircleComponent {
  @Input('checked') checked: boolean = false
}
